import { uiActions } from "../store/uiSlice";
import { fetchNoToken } from "../helpers/fetch";

export const openModal = () => {
  return async (dispatch) => {
    dispatch(uiActions.setIsModalOpen(true));
  };
};

export const closeModal = () => {
  return async (dispatch) => {
    dispatch(uiActions.setIsModalOpen(false));
  };
};

export const setModalTitle = (value) => {
  return async (dispatch) => {
    dispatch(uiActions.setModalTitle(value));
  };
};

export const setModalText = (value) => {
  return async (dispatch) => {
    dispatch(uiActions.setModalText(value));
  };
};

export const setModalBody = (value) => {
  return async (dispatch) => {
    dispatch(uiActions.setModalBody(value));
  };
};

export const setModalConfirmText = (value) => {
  return async (dispatch) => {
    dispatch(uiActions.setModalConfirmText(value));
  };
};

export const setModalCancelText = (value) => {
  return async (dispatch) => {
    dispatch(uiActions.setModalCancelText(value));
  };
};

export const showSimpleMessage = (title, text) => {
  return async (dispatch) => {
    try {
      dispatch(setModalTitle(title));
      dispatch(setModalText(text));
      dispatch(openModal());
      dispatch(setModalConfirmText("Aceptar"));
    } catch (error) {
      console.log("Exception:", error);
    }
  };
};

export const setShowRentSlider = (value) => {
  return async (dispatch) => {
    dispatch(uiActions.setShowRentSlider(value));
  };
};

export const setShowBuySlider = (value) => {
  return async (dispatch) => {
    dispatch(uiActions.setShowBuySlider(value));
  };
};

export const setValuesRentSlider = (min, max) => {
  return async (dispatch) => {
    dispatch(uiActions.setMinRentSlider(min));
    dispatch(uiActions.setMaxRentSlider(max));
  };
};

export const setValuesBuySlider = (min, max) => {
  return async (dispatch) => {
    dispatch(uiActions.setMinBuySlider(min));
    dispatch(uiActions.setMaxBuySlider(max));
  };
};

export const setSelectedRentBuy = (value) => {
  return async (dispatch) => {
    if (value == "rent") {
      dispatch(uiActions.setShowBuySlider(false));
      dispatch(uiActions.setShowRentSlider(true));
    } else if (value == "buy") {
      dispatch(uiActions.setShowBuySlider(true));
      dispatch(uiActions.setShowRentSlider(false));
    } else {
      dispatch(uiActions.setShowBuySlider(false));
      dispatch(uiActions.setShowRentSlider(false));
    }
    dispatch(uiActions.setSelectedRentBuy(value));
  };
};

export const setSelectedPropertyType = (val) => {
  return async (dispatch) => {
    dispatch(uiActions.setSelectedPropertyType(val));
  };
};

export const setSelectedPlace = (val) => {
  return async (dispatch) => {
    dispatch(uiActions.setSelectedPlace(val));
  };
};

export const startGetAvailablePlaces = () => {
  return async (dispatch) => {
    try {
      const response = await fetchNoToken("available_places");
      const body = await response.json();
      if (body.errors) {
      } else {
        dispatch(uiActions.setAvailablePlaces(body));
      }
    } catch (error) {
      console.log("Exception:", error);
    }
  };
};

export const startGetAvailablePropertyTypes = () => {
  return async (dispatch) => {
    try {
      const response = await fetchNoToken("available_property_types");
      const body = await response.json();
      if (body.errors) {
      } else {
        dispatch(uiActions.setAvailablePropertyTypes(body));
      }
    } catch (error) {
      console.log("Exception:", error);
    }
  };
};
